import { Translate } from '@chipinside/translate'
import { Button, Stack, Tooltip } from '@mui/material'
import { isEmpty } from 'lodash'

import { Dialog } from '#/components/Dialog'
import TypeMultiData from '#/components/FormatCell/Types/MultiData'
import ImportUnrecognizedData from '#/components/Jobs/UnrecognizedData'
import { copyToClipboard } from '#/utils/copyToClipboard'

type Props = {
  value: {
    values: string[]
    data_type_text: string
  }
}

const MAX = 10

export default function TypeImportUnrecognizedData({ value }: Props) {
  if (isEmpty(value?.values)) return <p>-</p>

  const { data_type_text, values } = value

  const totalCount = values?.length

  const show = values?.slice(0, MAX)
  const hide = values?.slice(MAX, totalCount)

  const chips = show?.map(
    v =>
      ({
        onClick: () => copyToClipboard(v),
        tooltip: Translate({ messageKey: 'copy' }),
        type: 'chip',
        value: v,
        variant: 'soft',
        width: 'unset',
      }) as const,
  )

  const handleOpen = () =>
    Dialog.open({
      content: <ImportUnrecognizedData values={values} />,
      header: {
        subtitle: Translate({
          lower: [false, true],
          messageKey: [String(totalCount), 'results'],
          separator: ' ',
        }),
        title: Translate({ messageKey: ['data_not_recognized', data_type_text], separator: ' - ' }),
      },
    })

  return (
    <Stack direction="row" sx={{ alignItems: 'flex-end', gap: 1 }}>
      <TypeMultiData value={chips} spacing={0} sx={{ flexWrap: 'wrap', gap: 1 }}>
        {!isEmpty(hide) && (
          <Tooltip title={Translate({ messageKey: 'view_all' })}>
            <Button
              color="error"
              sx={{ minHeight: 22, minWidth: 'unset', px: 1, py: 0 }}
              onClick={handleOpen}
            >
              +{hide.length}
            </Button>
          </Tooltip>
        )}
      </TypeMultiData>
    </Stack>
  )
}
